import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import SignaturePad from 'signature_pad';
import { NgSignaturePad } from './models/ng-signaturepad.interfaces';

@Component({
  selector: 'ng-signaturepad',
  template: `<canvas [width]="_width" [height]="_height" style="touch-action: none;"></canvas>`,
  standalone: false,
})
export class NgSignaturePadComponent implements NgSignaturePad, OnInit, AfterViewInit {
  public _width: number = 200;
  public _height: number = 200;
  public _options: any = {};

  private _canvas: any;
  private _signaturePad: any;

  @Input() set options(options: any) {
    this._options = options;
    if (this._signaturePad) {
      this._signaturePad = new SignaturePad(this._canvas, this._options || {});
    }
  }

  @Input() set width(value: number) {
    this._width = value;
  }

  @Input() set height(value: number) {
    this._height = value;
  }

  constructor(private _el: ElementRef) {}

  public ngOnInit(): void {
    if (this.options) {
      this._options = this.options;
    }
  }

  public ngAfterViewInit(): void {
    this._canvas = this._el.nativeElement.querySelector('canvas');
    this._signaturePad = new SignaturePad(this._canvas, this._options || {});
  }

  public toDataURL(type = null): string {
    return this._signaturePad.toDataURL(type);
  }

  public fromDataURL(data: string): void {
    this._signaturePad.fromDataURL(data);
  }

  public toData(): any {
    return this._signaturePad.toData();
  }

  public fromData(data: any): void {
    this._signaturePad.fromData(data);
  }

  public clear(): void {
    this._signaturePad.clear();
  }

  public isEmpty(): boolean {
    return this._signaturePad.isEmpty();
  }

  public off(): void {
    this._signaturePad.off();
  }

  public on(): void {
    this._signaturePad.on();
  }
}
